export default __webpack_public_path__ + "static/media/graduate.c9770593.png";